import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { FolderOpen } from 'lucide-react';
import { motion } from 'framer-motion';
const documentCategories = ['Нормативні документи', 'Рішення скельного комітету', 'Рішення тренерської ради', 'Правила проведення змагань', 'Регламенти', 'Протоколи', 'Рейтинги'];
export function ClimbingDocuments() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-523">
      <Header data-id="element-524" />
      <main className="pt-20" data-id="element-525">
        <PageHero label="Скелелазіння" title="Документи скельного комітету" subtitle="Офіційні документи скельного комітету ФАіСУ" data-id="element-526" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-527">
          <div className="space-y-4 mt-10" data-id="element-528">
            {documentCategories.map((category, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} data-id="element-529">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 flex items-center gap-4 group cursor-pointer hover:border-primary/30 hover:shadow-md transition-all" data-id="element-530">
                  <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0 text-primary group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-531">
                    <FolderOpen className="h-5 w-5" data-id="element-532" />
                  </div>
                  <h3 className="text-base font-medium text-gray-800 group-hover:text-primary transition-colors" data-id="element-533">
                    {category}
                  </h3>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-534" />
    </div>;
}